import store from "../store";

export const SELECT_CAR = "SELECT_CAR";

export const selectCar = car => {
  return function(dispatch) {
    dispatch(selectCarSuccess(car));
  };
};

export const selectCarSuccess = response => {
  return {
    type: SELECT_CAR,
    car: response
  };
};
